import { render } from "./EmailDashboard.vue?vue&type=template&id=7c2cbb65&scoped=true&ts=true"
import script from "./EmailDashboard.vue?vue&type=script&lang=ts"
export * from "./EmailDashboard.vue?vue&type=script&lang=ts"

import "./EmailDashboard.vue?vue&type=style&index=0&id=7c2cbb65&scoped=true&lang=css"
import "./EmailDashboard.vue?vue&type=style&index=1&id=7c2cbb65&lang=scss"
import "./EmailDashboard.vue?vue&type=style&index=2&id=7c2cbb65&scoped=true&lang=css"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c2cbb65"]])

export default __exports__